
import masters from './masters'


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [masters]
};

export default menuItems;
